<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="4">
          <el-input v-model="form.code" size="small" placeholder="发票编号" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input v-model="form.applicantName" size="small" placeholder="开票申请人" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input v-model="form.contractName" size="small" placeholder="合同名称/编号" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
        </el-col>
         <el-col :span="5" class="input-group">
          <el-select v-model="form.showStatusList" multiple size="small" placeholder="开票状态" class="w-100">
            <el-option v-for="(item, index) in getStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" class="input-group">
          <el-date-picker v-model="form.startTime" type="date" placeholder="最早申请时间" size="small" value-format="yyyy-MM-dd 00:00:00" :picker-options="pickerMin">
          </el-date-picker>
          <span>~</span>
          <el-date-picker v-model="form.endTime" type="date" placeholder="最近申请时间" size="small" value-format="yyyy-MM-dd 23:59:59" :picker-options="pickerMax">
          </el-date-picker>
        </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">外部平台开票总数：{{ page.total }}条</div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small"  >
        <el-table-column label="发票编号" prop="code" align="center"></el-table-column>
        <el-table-column label="开票申请时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="开票申请人" prop="applicantName" align="center"></el-table-column>
        <el-table-column label="批次名称" prop="batchName" align="center"></el-table-column>
        <el-table-column label="开票金额" prop="invoiceMoney" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.invoiceMoney) }}
          </template>
        </el-table-column>
        <el-table-column label="开票类型" prop="invoiceType" align="center">
          <template slot-scope="scope">
            {{ billingConfig.getAppointed("status", scope.row.invoiceType) }}
          </template>
        </el-table-column>
        <el-table-column label="开票明细" prop="invoiceDetail" align="center">
          <template slot-scope="scope">
            {{
              billingConfig.getAppointed(
                "invoice_status",
                scope.row.invoiceDetail
              )
            }}
          </template>
        </el-table-column>
        <el-table-column label="发票照片" prop="invoicePhotoList" align="center">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.invoicePhotoList"></filePreview>
          </template>
        </el-table-column>
        <el-table-column label="快递单号" prop="expressNumber" align="center"></el-table-column>
        <el-table-column label="开票状态" prop="status" align="center">
          <template slot-scope="scope">
            <template >
              <div v-for="(item,index) in getStatusList" :key="index">
                {{scope.row.status == item.value ?item.label:''}}
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
   
    </div>
  </div>
</template>

<script>
import xlsx from "xlsx";
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/invoice";
import { deliveryConfig } from "@/const/config/delivery";
import { billingConfig,billingShow } from "@/const/config/billing";
import { approveConfig } from "@/const/config/approve";
import { listInvoice } from "@/api/business/platform";
import {
  getFinAccount , listCustom
} from "@/api/business/contract";
import { mapGetters } from "vuex";
import * as qiniu from "qiniu-js";
import { qiniuToken } from "@/api/index";
export default {
  components: {
  },
  data() {
    var that = this;
    return {
      approveConfig, billingConfig ,
      contractConfig: contractConfig,
      pickerMin: {
        disabledDate(time) {
          if (validate.checkNull(that.form.endTime)) return false;
          return time.getTime() > new Date(that.form.endTime).getTime();
        },
      },
      pickerMax: {
        disabledDate(time) {
          if (validate.checkNull(that.form.startTime)) return false;
          return time.getTime() < new Date(that.form.startTime).getTime();
        },
      },
      //调整监测时间规则
      timeOptionRange: "",
      jobRangePicker: {
        onPick: (time) => {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          let t = new Date(dateFormat(new Date()).split(" ")[0] + " 00:00:00");
          let timeOptionRange = this.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 6 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() <= t.getTime() ||
              time.getTime() < timeOptionRange.getTime() - secondNum ||
              time.getTime() > timeOptionRange.getTime() + secondNum
            );
          }
          return time.getTime() <= t.getTime();
        },
      },
      ruleForm:{
        path:"",
        name:"",
        desc:"",
      },
      form: {
        code: "", //发票编号
        applicantName: "", //开票申请人
        batchName: "", //合同名称
        customerName: "", //客户名称
        showStatusList: "", //开票状态
        startTime: "", //起始时间
        endTime: "", //结束时间
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      yhgAccountList:[],
      submitLoading: false,
      customListModal:false,
      rules: {
        finAccountId: [
          { required: true, message: "请选择开票主体", trigger: "change" },
        ],
      },
      getStatusList:[
        { value: 1,label: '审批中'},
        { value: 2,label: '审批不通过'},
        { value: 3,label: '审批通过未上传发票'},
        { value: 4,label: '审批通过已上传发票'},
        { value: 5,label: '作废'},
        { value: 6,label: '作废审批中'},
        
      ],

    };

  },
  mounted() {
    this.getList();
  },
  methods: {

    //获取有花果账户列表
    getYhgAccount() {
      getFinAccount({type:0})
        .then((res) => {
          this.yhgAccountList = res.data || [];
        })
        .catch((err) => {
          this.yhgAccountList = [];
        });
    },

    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    customSizeChange(val) {
      this.customPage.pageNum = 1;
      this.customPage.pageSize = val;
      this.getCustomList();
    },




    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        code: "", //发票编号
        applicantName: "", //开票申请人
        batchName: "", //合同名称
        customerName: "", //客户名称
        showStatusList: "", //开票状态
        startTime: "", //起始时间
        endTime: "", //结束时间
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      listInvoice(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },




    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table__header-wrapper  .el-checkbox{
	display:none
}

.form-block {
  position: relative;
  padding-bottom: 20px;

  &.has-divider.top:before {
    content: "";
    position: absolute;
    left: -15px;
    right: -15px;
    top: -15px;
    height: 10px;
    display: block;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }
  &.has-divider.bottom:after {
    content: "";
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: 0;
    height: 10px;
    display: block;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }

  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }

  &-submit {
    padding-top: 15px;
    text-align: center;
  }

  .block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-32 {
      display: inline-block;
      width: 32%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
}

.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
/deep/.select-con {
  .el-tag .el-icon-close {
    top: -1px;
  }
}
</style>

<style lang="scss">
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
.orderBox{
  display: flex;
  align-items: center;
}
</style>